<template>
	<v-app>
		<default-bar />

		<default-drawer />

		<default-view v-if="appLoaded" />

		<default-footer />

	</v-app>
</template>

<script>
	import { call } from 'vuex-pathify'

	export default {
		name: 'DefaultLayout',

		components: {
			DefaultBar: () => import(
				/* webpackChunkName: "default-app-bar" */
				'./AppBar'
			),
			DefaultDrawer: () => import(
				/* webpackChunkName: "default-drawer" */
				'./Drawer'
			),
			DefaultFooter: () => import(
				/* webpackChunkName: "default-footer" */
				'./Footer'
			),
			DefaultView: () => import(
				/* webpackChunkName: "default-view" */
				'./View'
			),
		},
		data() {
			return {
				appLoaded: false
			}
		},
		mounted() {
			this.loadAppSettings({ force: true }).then(res => {
				this.appLoaded = true
			})
			this.refreshUserClaims()
		},
		methods: {
			loadAppSettings: call('appSettings/fetch'),
			refreshUserClaims: call('auth/refreshUserClaims')
		}
	}
</script>
